<template lang="pug">
include plugins/pug/template
div
  div(v-if="isLoadApp")
    v-app(v-if="isGuestRoute")
      div(:class="isLoginRoute && 'login-background'").d-flex.flex-grow-1.justify-center.public-route
        router-view
    v-app(v-else)
      Navigation.main-navigation

      v-app-bar(app color="#ffffff" flat outlined dense).header-app-bar
        v-toolbar-items(style="width: 100%")
          v-spacer

          NotificationButton

          div.d-flex.flex-column.justify-center
            div(style="line-height: 1.2") {{ profile.last_name }} {{ profile.first_name }}
            div.caption(style="line-height: 1; color: #b3b3b3") {{ profile.email }} (id: {{profile.id}})

          v-divider(vertical).ml-8.mr-0

          +btn-icon-text-simple('', 'signOut', 'mdi-exit-to-app')(@click="logoutApp")

      ExplanationDialog

      div(:class="isMini&& 'v-main-mini'").v-main
        router-view
  div(v-else)
    Loader
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { logout } from '@ananasbear/auth'
import { access } from '@/configs/permissions'
import indexedDB from '@/mixins/indexedDB'
import Navigation from '@/components/Navigation'
import Header from '@/components/Header'
import Loader from '@/views/Loader'
import NotificationButton from '@/components/Notification/NotificationButton.vue'

export default {
  name: 'App',
  components: {
    NotificationButton,
    Navigation,
    Header,
    Loader
  },
  mixins: [indexedDB],
  data () {
    return {
      isGuestRoute: true,
      isLoginRoute: false,
      access,
      logout
    }
  },
  computed: {
    ...mapState({
      isMini: state => state.app.isMini,
      isLoadApp: state => state.app.isLoad,
      profile: state => state.profile.profile,
      standId: state => state.measurement.currentStand
    }),
    theme () {
      return 'light'
    },
    isAuth () {
      return this.$auth.isAuth()
    }
  },
  watch: {
    '$route' (route) {
      this.isGuestRoute = route.meta.public || false
      this.isLoginRoute = ['login', 'forgot', 'forgot-password'].includes(route.name) || false
    }
  },
  mounted () {
    window.chatwootSettings = {
      hideMessageBubble: true
    }
    const interval = setInterval(() => {
      if (access('guestUser') !== undefined) {
        clearInterval(interval)
        if (this.isAuth && !access('guestUser')) this.getDirectories()
      }
    }, 50)
  },
  methods: {
    ...mapMutations(['SET_DATA']),
    ...mapActions([
      'getDirectories',
      'turnOffTheStand'
    ]),
    logoutApp () {
      if (this.standId) this.turnOffTheStand(this.standId)
      if (access('guestUser')) {
        localStorage.removeItem('cabinetType')
        localStorage.removeItem('isAccountSelection')
      }
      this.logout()
      this.SET_DATA({ store: 'profile', state: 'profile', data: {} })
      if (window.$chatwoot) window.$chatwoot.reset()
      this.$router.push('/login').catch(() => {})
    }
  }
}
</script>
